import { useQuery } from '@tanstack/react-query';
import { organizacaoApi, type Organizacao } from '../api/organizacao';
import { useIsAuthenticated } from './useAuth';

/**
 * Dados cadastrais da organização (logo, razão social, contato). Usado na
 * sidebar pra exibir identidade visual do cliente em vez do "UtilyHub" fixo,
 * e também pelo CatalogoDigitalPage. Cache longo — organização muda raramente.
 *
 * Só dispara request se autenticado — endpoint exige token.
 */
export const useOrganizacao = () => {
  const { isAuthenticated } = useIsAuthenticated();
  return useQuery<Organizacao>({
    queryKey: ['organizacao'],
    queryFn: () => organizacaoApi.obter(),
    enabled: isAuthenticated,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
};
